import React, { useState } from "react";
import "../../../assets/css/admin/EarningsManagement.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

// ── Icons ─────────────────────────────────────────────────────────────────────
const IconRevenue = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M12 6v2M12 16v2M8.5 9.5c0-1.1.9-2 2-2h3a2 2 0 0 1 0 4h-3a2 2 0 0 0 0 4h3a2 2 0 0 0 2-2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconPlatform = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <rect
      x="2"
      y="3"
      width="20"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M8 21H16M12 17V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconPayout = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <path
      d="M20 7H4C2.895 7 2 7.895 2 9V19C2 20.105 2.895 21 4 21H20C21.105 21 22 20.105 22 19V9C22 7.895 21.105 7 20 7Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3L20 7H4L8 3H16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="17" cy="14" r="1.5" fill="currentColor" />
  </svg>
);

const IconPercent = () => (
  <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
    <line
      x1="19"
      y1="5"
      x2="5"
      y2="19"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="6.5" cy="6.5" r="2.5" stroke="currentColor" strokeWidth="2" />
    <circle cx="17.5" cy="17.5" r="2.5" stroke="currentColor" strokeWidth="2" />
  </svg>
);

const IconInfo = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
    <path
      d="M12 8h.01M12 12v4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconSave = () => (
  <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
    <path
      d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 21v-8H7v8M7 3v5h8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconTick = () => (
  <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
    <path
      d="M20 6L9 17L4 12"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconTrend = () => (
  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
    <path
      d="M23 6L13.5 15.5L8.5 10.5L1 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 6H23V12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ── Dummy data ─────────────────────────────────────────────────────────────────
const MONTHLY_DATA = [
  { month: "Aug", revenue: 38000, platform: 7600, mentor: 30400 },
  { month: "Sep", revenue: 42000, platform: 8400, mentor: 33600 },
  { month: "Oct", revenue: 45500, platform: 9100, mentor: 36400 },
  { month: "Nov", revenue: 47000, platform: 9400, mentor: 37600 },
  { month: "Dec", revenue: 49200, platform: 9840, mentor: 39360 },
  { month: "Jan", revenue: 50000, platform: 10000, mentor: 40000 },
];

const TOP_COURSES = [
  {
    id: 1,
    name: "Full Stack Development",
    sales: 142,
    revenue: 14200,
    commission: 2840,
  },
  {
    id: 2,
    name: "Data Science Bootcamp",
    sales: 98,
    revenue: 9800,
    commission: 1960,
  },
  {
    id: 3,
    name: "UI/UX Design Mastery",
    sales: 87,
    revenue: 8700,
    commission: 1740,
  },
  {
    id: 4,
    name: "Machine Learning A–Z",
    sales: 74,
    revenue: 7400,
    commission: 1480,
  },
  {
    id: 5,
    name: "Cloud Computing Basics",
    sales: 65,
    revenue: 6500,
    commission: 1300,
  },
];

// ── FIXED: fmt function was accidentally replaced with icon code ──────────────
const fmt = (n) => `Rs ${n.toLocaleString()}`;
// ─────────────────────────────────────────────────────────────────────────────

// ── Component ──────────────────────────────────────────────────────────────────
const Earnings = () => {
  const current = MONTHLY_DATA[MONTHLY_DATA.length - 1];

  const [commission, setCommission] = useState("20");
  const [commissionError, setCommissionError] = useState("");
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const commissionNum = parseFloat(commission) || 0;
  const previewPlatform = Math.round(current.revenue * (commissionNum / 100));
  const previewMentor = current.revenue - previewPlatform;

  const handleSave = (e) => {
    e.preventDefault();
    const val = parseFloat(commission);
    if (isNaN(val) || val < 0 || val > 100) {
      setCommissionError("Please enter a value between 0 and 100.");
      return;
    }
    setCommissionError("");
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3500);
    }, 800);
  };

  const handleCommissionChange = (e) => {
    setCommission(e.target.value);
    setCommissionError("");
    setSaveSuccess(false);
  };

  const maxRevenue = Math.max(...MONTHLY_DATA.map((d) => d.revenue));

  return (
    <AdminLayout>
      <div className="earn-page">
        {/* Page Header */}
        <div className="earn-topbar">
          <div>
            <h2 className="earn-page-title">Earnings Management</h2>
            <p className="earn-page-desc">
              Platform revenue overview and commission configuration
            </p>
          </div>
        </div>

        {/* KPI Summary Cards */}
        <div className="earn-stats-grid">
          <div className="earn-stat-card">
            <div className="earn-stat-card-top">
              <div className="earn-stat-icon earn-stat-icon--revenue">
                <IconRevenue />
              </div>
              <span className="earn-delta earn-delta--green">
                <IconTrend /> +8%
              </span>
            </div>
            <div className="earn-stat-number">{fmt(current.revenue)}</div>
            <div className="earn-stat-title">Total Revenue</div>
            <div className="earn-stat-sub">This month</div>
          </div>

          <div className="earn-stat-card">
            <div className="earn-stat-card-top">
              <div className="earn-stat-icon earn-stat-icon--platform">
                <IconPlatform />
              </div>
              <span className="earn-delta earn-delta--blue">
                {commissionNum}% cut
              </span>
            </div>
            <div className="earn-stat-number">{fmt(current.platform)}</div>
            <div className="earn-stat-title">Platform Earnings</div>
            <div className="earn-stat-sub">
              After {commissionNum}% commission
            </div>
          </div>

          <div className="earn-stat-card">
            <div className="earn-stat-card-top">
              <div className="earn-stat-icon earn-stat-icon--payout">
                <IconPayout />
              </div>
              <span className="earn-delta earn-delta--orange">
                {100 - commissionNum}% share
              </span>
            </div>
            <div className="earn-stat-number">{fmt(current.mentor)}</div>
            <div className="earn-stat-title">Mentor Payouts</div>
            <div className="earn-stat-sub">Distributed to mentors</div>
          </div>
        </div>

        {/* Revenue Trend + Commission Settings */}
        <div className="earn-row-2">
          {/* Bar Chart */}
          <div className="earn-card earn-card--chart">
            <div className="earn-card-header">
              <div>
                <h3 className="earn-card-title">Revenue Trend</h3>
                <p className="earn-card-sub">Last 6 months</p>
              </div>
            </div>
            <div className="earn-chart-body">
              <div className="earn-bar-chart">
                {MONTHLY_DATA.map((d) => {
                  const totalH = Math.round((d.revenue / maxRevenue) * 100);
                  const platformH = Math.round((d.platform / maxRevenue) * 100);
                  return (
                    <div key={d.month} className="earn-bar-group">
                      <div className="earn-bar-wrap">
                        <div
                          className="earn-bar earn-bar--total"
                          style={{ height: `${totalH}%` }}
                          title={`Total: ${fmt(d.revenue)}`}
                        />
                        <div
                          className="earn-bar earn-bar--platform"
                          style={{ height: `${platformH}%` }}
                          title={`Platform: ${fmt(d.platform)}`}
                        />
                      </div>
                      <span className="earn-bar-label">{d.month}</span>
                    </div>
                  );
                })}
              </div>
              <div className="earn-legend">
                <span className="earn-legend-item">
                  <span className="earn-legend-dot earn-legend-dot--total" />
                  Total Revenue
                </span>
                <span className="earn-legend-item">
                  <span className="earn-legend-dot earn-legend-dot--platform" />
                  Platform Earnings
                </span>
              </div>
            </div>
          </div>

          {/* Commission Settings */}
          <div className="earn-card earn-card--commission">
            <div className="earn-card-header">
              <div className="earn-card-header-icon">
                <IconPercent />
              </div>
              <div>
                <h3 className="earn-card-title">Commission Settings</h3>
                <p className="earn-card-sub">
                  Platform deduction per course sale
                </p>
              </div>
            </div>

            <form
              className="earn-commission-form"
              onSubmit={handleSave}
              noValidate
            >
              <div className="earn-split-preview">
                <div className="earn-split-bar">
                  <div
                    className="earn-split-fill earn-split-fill--platform"
                    style={{ width: `${Math.min(commissionNum, 100)}%` }}
                  />
                  <div
                    className="earn-split-fill earn-split-fill--mentor"
                    style={{ width: `${Math.max(100 - commissionNum, 0)}%` }}
                  />
                </div>
                <div className="earn-split-labels">
                  <span className="earn-split-label earn-split-label--platform">
                    Platform {commissionNum}%
                  </span>
                  <span className="earn-split-label earn-split-label--mentor">
                    Mentor {Math.max(100 - commissionNum, 0)}%
                  </span>
                </div>
              </div>

              <div className="earn-form-group">
                <label className="earn-label" htmlFor="commission-input">
                  Commission Percentage <span className="earn-required">*</span>
                </label>
                <div className="earn-input-wrap">
                  <input
                    id="commission-input"
                    type="number"
                    min="0"
                    max="100"
                    step="0.5"
                    className={`earn-input${commissionError ? " earn-input--error" : ""}`}
                    value={commission}
                    onChange={handleCommissionChange}
                    placeholder="20"
                  />
                  <span className="earn-input-suffix">%</span>
                </div>
                {commissionError && (
                  <span className="earn-field-error">{commissionError}</span>
                )}
              </div>

              <div className="earn-preview-row">
                <div className="earn-preview-item">
                  <span className="earn-preview-label">Platform gets</span>
                  <span className="earn-preview-value earn-preview-value--platform">
                    {fmt(previewPlatform)}
                  </span>
                </div>
                <div className="earn-preview-divider" />
                <div className="earn-preview-item">
                  <span className="earn-preview-label">Mentor gets</span>
                  <span className="earn-preview-value earn-preview-value--mentor">
                    {fmt(previewMentor)}
                  </span>
                </div>
              </div>
              <p className="earn-preview-note">
                Based on current month revenue of {fmt(current.revenue)}
              </p>

              <div className="earn-info-box">
                <span className="earn-info-icon">
                  <IconInfo />
                </span>
                <p className="earn-info-text">
                  This percentage is deducted from each course sale before
                  mentor payout. Changes apply to all future transactions.
                </p>
              </div>

              <button
                type="submit"
                className={`earn-btn earn-btn--primary${isSaving ? " earn-btn--loading" : ""}`}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span className="earn-spinner" /> Saving…
                  </>
                ) : saveSuccess ? (
                  <>
                    <IconTick /> Saved!
                  </>
                ) : (
                  <>
                    <IconSave /> Save Changes
                  </>
                )}
              </button>

              {saveSuccess && (
                <div className="earn-success-msg">
                  <IconTick /> Commission updated to {commission}% successfully.
                </div>
              )}
            </form>
          </div>
        </div>

        {/* Top Earning Courses Table */}
        <div className="earn-card">
          <div className="earn-card-header earn-card-header--between">
            <div className="earn-card-header-left">
              <h3 className="earn-card-title">Top Earning Courses</h3>
              <span className="earn-table-count">
                {TOP_COURSES.length} courses
              </span>
            </div>
            <span className="earn-commission-badge">
              Current Commission: {commission}%
            </span>
          </div>

          <div className="earn-table-wrapper">
            <table className="earn-table">
              <thead>
                <tr>
                  <th>#ID</th>
                  <th>Course Name</th>
                  <th className="earn-th--right">Sales</th>
                  <th className="earn-th--right">Revenue</th>
                  <th className="earn-th--right">Platform Cut</th>
                  <th className="earn-th--right">Mentor Payout</th>
                </tr>
              </thead>
              <tbody>
                {TOP_COURSES.map((course, idx) => {
                  const cut = Math.round(
                    course.revenue * (commissionNum / 100),
                  );
                  const payout = course.revenue - cut;
                  return (
                    <tr key={course.id}>
                      <td>
                        <span className="earn-id-badge">
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                      </td>
                      <td>
                        <span className="earn-course-name">{course.name}</span>
                      </td>
                      <td className="earn-td--right">
                        <span className="earn-sales-pill">{course.sales}</span>
                      </td>
                      <td className="earn-td--right">
                        <span className="earn-amount">
                          {fmt(course.revenue)}
                        </span>
                      </td>
                      <td className="earn-td--right">
                        <span className="earn-amount earn-amount--platform">
                          {fmt(cut)}
                        </span>
                      </td>
                      <td className="earn-td--right">
                        <span className="earn-amount earn-amount--mentor">
                          {fmt(payout)}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr className="earn-tfoot-row">
                  <td colSpan={2} className="earn-tfoot-label">
                    Total
                  </td>
                  <td className="earn-td--right earn-tfoot-val">
                    {TOP_COURSES.reduce((s, c) => s + c.sales, 0)}
                  </td>
                  <td className="earn-td--right earn-tfoot-val">
                    {fmt(TOP_COURSES.reduce((s, c) => s + c.revenue, 0))}
                  </td>
                  <td className="earn-td--right earn-tfoot-val earn-amount--platform">
                    {fmt(
                      TOP_COURSES.reduce(
                        (s, c) =>
                          s + Math.round((c.revenue * commissionNum) / 100),
                        0,
                      ),
                    )}
                  </td>
                  <td className="earn-td--right earn-tfoot-val earn-amount--mentor">
                    {fmt(
                      TOP_COURSES.reduce(
                        (s, c) =>
                          s +
                          (c.revenue -
                            Math.round((c.revenue * commissionNum) / 100)),
                        0,
                      ),
                    )}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Earnings;
